module.exports = __webpack_public_path__ + "img/3-11.1f1b3115.png";